import http from '../../api/http';
/**
 * 聚合付校验配置参数获取
 */
export const getCampusPay = (params) => http("get", '/project/campusPay/verify/param', params)
/**
 * 
 *  {绑定校园聚合付}  
 */

export const userBindCampusPay = (params) => http("post",
    '/user/campusPay/bind?projectId=' + params.projectId +
    '&verificationAccount=' + params.verificationAccount +
    '&userId=' + params.userId + '&verificationPassword=' +
    params.verificationPassword + '&loginCode=' + params.loginCode + '&accountId=' + params.accountId + '&verificationPasswordTwo=' + params.verificationPasswordTwo+'&phoneSystem='+params.phoneSystem)